import React from "react";
import {ellips} from './../../../assets'
import { Button, Input } from "../../Generic";
import { Link } from "react-router-dom";

const Forms = () => {
  return (
    <form className="sm:w-[387px] w-full">
      <img className="absolute top-[40%] left-[15%] z-0 md:left-[42%]" src={ellips} alt="" />
      <Input type={"email"} id={"email"} placeholder={"Your username"} style={`text-gray-lightGray text-base py-4 px-[18px]`} />
      <Input type={"password"} id={"password"} placeholder={"Your password"} style={`text-gray-lightGray text-base py-4 px-[18px]`} />
      <div className="flex items-start mb-6">
        <div className="flex items-center h-5">
          <input
            id="remember"
            type="checkbox"
            value=""
            className="w-4 h-4 border border-gray-300 rounded-[0px] bg-white focus:ring-3 focus:ring-blue-300 dark:bg-gray-700 dark:border-gray-600 dark:focus:ring-blue-600 dark:ring-offset-gray-800 dark:focus:ring-offset-gray-800"
            required
          />
        </div>
        <label
          htmlFor="remember"
          className="ml-4 font-inter text-13px font-normal text-gray-darkGray "
        >
          Remember password
        </label>
      </div>
      <div className="flex justify-center gap-[10px] font-popins mb-[82px] mt-[40px]">
        <Link to={'/repair'} className="text-blue-chatBlue font-[Poppins] text-[12px]">Forgot Password?</Link>
        <div className="font-[Poppins] text-[12px]">or</div>
        <div className="text-blue-chatBlue font-[Poppins] text-[12px]">Login</div>
      </div>
      <Button link={'/'} value={'Login'}/>
      <Link to='verification' className="flex justify-center gap-[10px] font-popins mb-[82px] mt-[40px]">
        <div className="text-blue-chatBlue font-[Poppins] text-[12px]">If you don’t have an account</div>
        <div className="font-[Poppins] text-[12px]">Sign up</div>
      </Link>

    </form>
  );
};

export default Forms;
